// src/components/business_landing/BHero.jsx
import React from 'react';
import './BHero.css'; // <-- 🩹 CIRUGÍA 1: Importamos el CSS modular

function BHero({ onScrollTo }) {

  const handleScroll = (sectionId) => {
    if (onScrollTo) {
      onScrollTo(sectionId);
    }
  };

  return (
    // 🩹 CIRUGÍA 2: Clase principal "b-hero-section" y 'id="hero"'
    <section className="b-hero-section" id="hero">
      <div className="container">
        
        {/* 🩹 CIRUGÍA 3: Eliminamos el style={{...}} y añadimos una clase wrapper */}
        <div className="b-hero-content-wrapper">
          <div className="hero-badge">🏢 Transformación Empresarial</div>
          <h1 className="hero-h1">
            Capacita a tu equipo en inglés
            con <span className="highlight">resultados medibles</span>
          </h1>
          <p className="hero-subtitle">
            Plataforma híbrida de IA + Profesores certificados por Cambridge para empresas que necesitan equipos bilingües de alto rendimiento. ROI comprobado en 90 días con métricas en tiempo real y profesores especializados en negocios.
          </p>
          
          {/* 🩹 CIRUGÍA 4: Eliminamos el style={{...}} del contenedor CTA */}
          <div className="hero-cta-container">
            <button className="hero-cta" onClick={() => handleScroll('contact')}>Solicitar Demo Gratuita</button>
            <button className="hero-cta-secondary" onClick={() => handleScroll('dashboard')}>Ver Dashboard</button>
          </div>
        </div>
        
        <div className="hero-stats">
          <div className="stat">
            <span className="stat-number">5+</span>
            <span className="stat-label">Empresas Activas</span>
          </div>
          <div className="stat">
            <span className="stat-number">380+</span>
            <span className="stat-label">Empleados Capacitados</span>
          </div>
          <div className="stat">
            <span className="stat-number">87%</span>
            <span className="stat-label">Mejora Promedio</span>
          </div>
          <div className="stat">
            <span className="stat-number">4.9</span>
            <span className="stat-label">⭐⭐⭐⭐⭐ Rating</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BHero;